<template>
  <a-modal :title="`${props.tableColumnsData.full_name}`" :width="800" :open="true" @cancel="cancel">
    <template #footer>
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" :loading="state.submitLoading" @click="onFormSubmit">确定</a-button>
    </template>
    <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout">
        <a-form-item name="investor_letter" htmlFor="{null}" label="全体投资人承诺书">
          <Upload
            :upload_path="props.tableColumnsData.upload_path"
            :accept="['jpg']"
            uploadType="picture-card"
            :limitation="99"
            v-model:value="formState.investor_letter"
            uploadText="全体投资人承诺书"
            :size="1"
          >
          </Upload>
        </a-form-item>
        <a-form-item name="muban" htmlFor="{null}" label="下载全体投资人承诺书模板">
          <a-popover trigger="click" overlayClassName="customer-options-popover" placement="right">
            <template #content>
              <div v-for="(item, index) in props.tableColumnsData.DownType" :key="index" @click="downLease(item)">
                <p>{{ item.name }}</p>
              </div>
            </template>
            <a>下载</a>
          </a-popover>
        </a-form-item>
      </a-form>
    </a-skeleton>
  </a-modal>
</template>
<script lang="ts" setup>
import { reactive, onMounted, ref } from 'vue'
import Upload from '@/components/base/Upload.vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import ls from '@/utils/Storage'
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const emit = defineEmits(['cancel', 'ok'])
const formLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}
interface IformData {
  investor_letter: object[] | undefined
}
const formState = reactive<IformData>({
  investor_letter: []
})
interface state {
  loading: boolean
  submitLoading: boolean
}
const state = reactive<state>({
  loading: false,
  submitLoading: false
})
const props = defineProps({
  tableColumnsData: {
    type: Object,
    default: () => {}
  }
})
onMounted(() => {
  if (props.tableColumnsData.investor_letter) {
    formState.investor_letter = props.tableColumnsData.investor_letter
  }
})
// 提交
const onFormSubmit = () => {
  if (formState.investor_letter?.length == 0) {
    message.error('请上传全体投资人承诺书')
    return
  }
  state.submitLoading = true
  let requestParam = {
    url: '/admin/v1/calcel/uploadLetter',
    method: 'post',
    data: {
      id: props.tableColumnsData.id,
      investor_letter: formState.investor_letter
    }
  }
  baseService(requestParam)
    .then((res: any) => {
      message.success(res.msg)
      emit('ok')
    })
    .catch((res) => {
      if (res.msg) {
        message.error(res.msg)
      } else {
        message.error('操作失败,请稍后重试')
      }
    })
    .finally(() => {
      state.submitLoading = false
    })
}
const cancel = () => {
  emit('cancel')
}
//公司下载全体投资人承诺书
const downLease = (downItem) => {
  if (downItem?.children?.length > 0) {
    return
  }
  let url = downItem.url.replace('https://console.cskaiyela.com/hncskaiyela', '')
  const hide = message.loading({
    content: '等待下载中,请稍等',
    duration: 0,
    class: 'loading-message'
  })
  let requestParam = {
    url: url,
    method: 'get'
  }
  baseService(requestParam)
    .then((res) => {
      let a = document.createElement('a')
      let event = new MouseEvent('click')
      a.download = ''
      a.href = downItem.url + `&token=${token}&down=1`
      a.dispatchEvent(event)
      setTimeout(hide, 2000)
    })
    .catch((res) => {
      setTimeout(hide, 500)
      if (res.msg) {
        message.error(res.msg)
      } else {
        message.error('操作失败,请联系管理员')
      }
    })
}
</script>
<style lang="less" scoped>
.customer-options-popover {
  p {
    padding: 0 16px;
    margin: 0;
    height: 35px;
    line-height: 35px;
    cursor: pointer;
    text-align: center;
    color: #000;
  }

  p:hover {
    color: var(--ant-primary-color);
    background: var(--ant-primary-color-deprecated-bg);
  }
}
</style>
